import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $slider = $sectionInstance.find( '.section-production-podcasts-slider' );

		if ( !$slider.length || $slider[0].swiper ) {
			return;
		}

		new Swiper( $slider[0], {
			loop: true,
			speed: 1000,
			spaceBetween: 20,

			slidesPerView: 1,
			slidesPerGroup: 1,

			breakpoints: {
				480: {
					slidesPerView: 2,
					slidesPerGroup: 1,
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 1,
				},
				1024: {
					slidesPerView: 5,
					slidesPerGroup: 2,
				},
				1280: {
					slidesPerView: 8,
					slidesPerGroup: 2,
				},
			},

			navigation: {
				nextEl: $sectionInstance.find( '.swiper-button-next' )[0],
				prevEl: $sectionInstance.find( '.swiper-button-prev' )[0],
			},

			pagination: {
				el: $sectionInstance.find( '.swiper-pagination' )[0],
				clickable: true,
			},
		} );
	} );
};

app.loadBlock( initBlock, 'production-podcasts', '.section-production-podcasts' );

if ( module.hot ) {
	module.hot.accept();
}
